import React, { useState, useEffect, FC } from "react";
import { DRRuleResolver } from "services/DRSolverService";

import RepaymentCalendarHeader from "./RepaymentCalendarHeader";
import RepaymentCalendarBody from "./RepaymentCalendarBody";
import { DRCalendarInput, DRCalendarOutput } from "types/DRInterface";

const calendarHeaders = [
  "Payment",
  "Beginning Balance",
  "Principal",
  "Interest",
  "Ending Balance",
];

const LoanRepaymentCalendar: FC<DRCalendarInput> = (props) => {
  const [calendarValues, setCalendarValues] = useState<DRCalendarOutput>([]);
  const [isGenerating, setIsGenerating] = useState<boolean>(false);

  const getPaymentCalendar = async (inputValues: any) => {
    setIsGenerating(true);
    try {
      const res = await DRRuleResolver("802e4632-579b-643e-b2e4-746de78d1b56", inputValues)
      setCalendarValues(res[0].calendar);
      setIsGenerating(false);
      return res[0].calendar;
    } catch (Err) {
      setIsGenerating(false);
      console.error("DR Rule call error: ", Err);
      return [];
    }
  };

  useEffect(() => {
    // ? 300 ms nebo 500 ms debounce
    const delayDebounceFn = setTimeout(() => {
      getPaymentCalendar({
        loanAmount: props.loanAmount,
        loanDuration: props.loanDuration,
        interestRate: props.interestRate,
        monthlyPayment: props.monthlyPayment,
      })
    }, 300);

    return () => clearTimeout(delayDebounceFn);

  }, [props]);

  return (
    <div className="loan-repayment-calendar">
      <div className="container loan-repayment-calendar__container">
        <div className="calendar">
          <div className={`calendar__content-container ${(calendarValues.length === 0 || isGenerating === true) && "table-loader"}`}>
            <RepaymentCalendarHeader values={calendarHeaders} />
            {calendarValues.length === 0 ? (
              <RepaymentCalendarBody values={[{ beginningBalance: "", interest: "", principal: "", endingBalance: "" }]} />
            ) : (
                <RepaymentCalendarBody values={calendarValues} />
            )}
            </div>
        </div>
      </div>
    </div>
  );
};

export default LoanRepaymentCalendar;
